import { X } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils.ts";
import { usePopupStore } from "@/lib/hooks/conversations/use-popup-store.ts";

interface EscalationPopupProps {
  onClose: () => void;
  isOpen: boolean;
  position: "left" | "right";
  children: React.ReactNode;
  title: string;
  height?: string;
  width?: string;
}

export const EscalationPopup = ({
  onClose,
  isOpen,
  position,
  children,
  title,
  height = "640px",
  width = "500px",
}: EscalationPopupProps) => {
  const { setEscalationPopupOpen } = usePopupStore();

  const handleClose = () => {
    onClose();
    setEscalationPopupOpen(false);
  };

  return (
    <Card
      id="escalation-popup"
      className={cn(
        "popup-escalation absolute bottom-16 shadow-lg",
        position === "left" ? "left-0" : "right-0",
        !isOpen && "hidden",
      )}
      style={{ width }}
    >
      <div className="flex items-center justify-between border-b p-4">
        <h2 className="text-lg font-semibold">{title}</h2>
        <button
          onClick={handleClose}
          className="rounded-full p-1 hover:bg-gray-100"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="overflow-y-auto p-4" style={{ height }}>
        {children}
      </div>
    </Card>
  );
};
